export default "__VITE_ASSET__DsAmZYDx__"